import React, { useState, useEffect } from 'react';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { DEFAULT_CLICK_SPID } from '@tencent/slide-sdk-model';
import styles from './index.less';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Menu from '@tencent/dui/lib/components/Menu';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { IAnimationEditorService } from '@src/slide/application/service/animation-editor-manager/core/interface';
import { ISelectedAnimManager } from '@src/slide/application/service/selection/selected-anim-manager.interface';

interface IProps {
    selectionService?: ISelectionService;
    selectedAnimManager?: ISelectedAnimManager;
    getAnimationEditorService: () => IDynamicService<IAnimationEditorService> | undefined;
}

const AnimTriggerSelect = (props: IProps) => {
    const { selectionService, selectedAnimManager, getAnimationEditorService } = props;
    const [triggerSelectOptions, setOptions] = useState<{ value: string; name: string }[]>([]);

    const getSelectedId = () => {
        const selectedAnimList = selectedAnimManager?.selectedArray;
        if (!selectedAnimList?.length) return '';
        const value = selectedAnimList[0]?.clickSpid;
        if (!value) return DEFAULT_CLICK_SPID;
        if (selectedAnimList?.every(animModel => animModel?.clickSpid === value)) {
            return value;
        }
        return '';
    };

    useEffect(() => {
        getAnimationEditorService()
            ?.promise()
            .then((service) => {
                const options = service.getTriggerSelectOptions() as { value: string; name: string }[];
                setOptions(options);
            });
    }, []);

    const style = {
        fontSize: 12,
        cursor: 'default',
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    };

    const handleTriggerOptionMouseLeave = () => {
        if (!selectionService?.currentSlide) return;
        selectionService.currentSlide.highlightModelId = null;
    };

    const handleTriggerOptionMouseEnter = (elementId: string) => {
        if (!selectionService?.currentSlide) return;
        selectionService.currentSlide.highlightModelId = elementId;
    };

    const handleMenuClick = (id) => {
        handleTriggerOptionMouseLeave();
        // 调用modifyAnimation接口
        selectedAnimManager?.selectedArray?.forEach((animModel) => {
            const currentSlideModel = selectionService?.currentSlide;
            if (!currentSlideModel) return;
            const animListItem = currentSlideModel.animList.find(item => item.clickSpid === getSelectedId());
            if (!animListItem) return;
            const targetAnimModel = animListItem.data.find(item => item.id === animModel.id);
            if (!targetAnimModel) return;
            currentSlideModel?.modifyAnimation(targetAnimModel, { clickSpid: id });
            animModel.clickSpid = id;
        });
        selectedAnimManager?.clear();
    };

    return (
        <div className={styles['anim-trigger']}>
            <Menu onClick={handleMenuClick} type="with-icon" itemStyle={{ width: 160 }} selectedIds={[getSelectedId()]}>
                {triggerSelectOptions.map(ops => (
                    <div
                        key={ops.value}
                        onMouseEnter={() => handleTriggerOptionMouseEnter(ops.value)}
                        onMouseLeave={handleTriggerOptionMouseLeave}
                    >
                        <Menu.Item id={ops.value} style={{ display: 'block' }} key={ops.value} value={ops.value}>
                            <Tooltip
                                title={ops.name}
                                trigger="hover"
                                placement="bottom"
                                disabled={!ops.name || ops.name.length < 8}
                                overlayHoverable={false}
                            >
                                <span className="trigger-item-span" style={style}>
                                    {ops.name}
                                </span>
                            </Tooltip>
                        </Menu.Item>
                    </div>
                ))}
            </Menu>
        </div>
    );
};

export default AnimTriggerSelect;
